// overlayKit/BrandChips.tsx — horizontal N-column row at bottom.
// Each brand sits centered in its own 1/N split of the canvas width. Each chip
// fades in on its `atS` (no slide transition — just opacity). Whole row fades
// out at `outS`. Bottom inset matches Tag's bottom-left position (70px).
import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";
import { appear, FONT, TS, win } from "./utils";
import { useColor } from "./palette";

export type BrandChip = { name: string; atS: number };

export type BrandChipsProps = {
  brands: BrandChip[];
  /** Window-out time. inS is derived from first brand's atS - 0.2. */
  outS: number;
  /** Palette tokens (defaults: CREAM text, GOLD accent border). */
  textColor?: string;
  accentColor?: string;
};

export const BrandChips: React.FC<BrandChipsProps> = ({
  brands, outS, textColor = "primary", accentColor = "secondary",
}) => {
  const frame = useCurrentFrame();
  const { fps, width } = useVideoConfig();
  const t = frame / fps;
  const first = brands[0]?.atS ?? 0;
  const inS = first - 0.2;
  const op = win(t, inS, outS);
  if (op <= 0.001) return null;
  const textHex = useColor(textColor);
  const accentHex = useColor(accentColor);

  // Font scales modestly with column width so 3 vs 5 brands both fit cleanly.
  const colWidth = width / Math.max(1, brands.length);
  const fontSize = Math.round(Math.min(36, Math.max(22, colWidth / 9)));

  return (
    <div
      style={{
        position: "absolute",
        bottom: 18,
        left: 0,
        right: 0,
        fontFamily: FONT,
        opacity: op,
        display: "flex",
        flexDirection: "row",
      }}
    >
      {brands.map((b, i) => {
        const o = appear(t, b.atS, 0.18);
        return (
          <div
            key={i}
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <div
              style={{
                opacity: o,
                color: textHex,
                fontSize,
                fontWeight: 800,
                letterSpacing: "0.10em",
                textShadow: TS,
                borderLeft: `3px solid ${accentHex}`,
                paddingLeft: 12,
                textAlign: "left",
                whiteSpace: "nowrap",
              }}
            >
              {b.name}
            </div>
          </div>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
